function Input(props){
  return (<input className="form-control" type="text" {...props} />)
}

export default function InputForm({ modifiers, update }) {
  // get a copy
  const newState = modifiers.slice(0);
  return (
    <ul className="list-group">
      {modifiers.map((row, index) => {
        const key = "input" + index;

        return (
          <li className="list-group-item" key={key}>
            <div className="input-group mb-3">
              {/* always render the first input */}
              <Input
                value={row[0]}
                onChange={(e) => {
                  // update the value
                  newState[index][0] = e.target.value;
                  update(newState);
                }}
              />
              {row.length > 1 ? (
                <>

                {/*
                  if the row contains a synonym
                  render second value
                  and render button to remove synonym
                   */}
                  <Input
                    value={row[1]}
                    onChange={(e) => {
                      // update the value
                      newState[index][1] = e.target.value;
                      update(newState);
                    }}
                  />
                  <button
                    className="btn btn-outline-warning"
                    type="button"
                    title="Remove the synonym"
                    onClick={() => {
                      newState[index] = [modifiers[index][0]];
                      update(newState);
                    }}
                  >
                  <IconClipboardX />
                  </button>
                </>
              ) : (
                <>
                {/*
                  otherwise the row has a single value
                  show the buttons to
                  */}
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  title="Add a Keyword Synonym and expand the keyword list"
                  onClick={() => {
                    // update the value
                    newState[index] = modifiers[index].concat("");
                    update(newState);
                  }}
                >
                <IconClipboardPlus />
                </button></>
              )}

              {row.length > 1 ? (
                ""
              ) : (
                <button
                  className="btn btn-outline-danger"
                  type="button"
                  title="Remove this Modifier keyword"
                  onClick={() => {
                    const newState = modifiers.slice(0);
                    newState.splice(index, 1);
                    update(newState);
                  }}
                >
                <IconTrashFill />
                </button>
              )}
            </div>
          </li>
        );
      })}
      <li className="list-group-item d-grid">
        <button
          onClick={() => update(modifiers.concat([[""]]))}
          className="btn btn-outline-success btn-sm"
          title="Modifier Keyword increases the entire permutation set"
        >
        <IconFileEarmarkPlus />
          Add Modifier
        </button>
      </li>
    </ul>
  );
}

function IconClipboardX(){
  return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-x" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"/>
    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
  </svg>);
}

function IconTrashFill(){
  return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
  </svg>);
}

function IconFileEarmarkPlus(){
  return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus" viewBox="0 0 16 16">
    <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z"/>
    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
  </svg>)
}

function IconClipboardPlus(){
  return (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-plus" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"/>
    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
  </svg>)
}
